'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _CompanyIsPff = require('./CompanyIsPff.css');

var _CompanyIsPff2 = _interopRequireDefault(_CompanyIsPff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyIsPff = (_dec = (0, _reactCssModules2.default)(_CompanyIsPff2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyIsPff, _Component);

  function CompanyIsPff(props) {
    var _ret;

    (0, _classCallCheck3.default)(this, CompanyIsPff);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyIsPff.__proto__ || (0, _getPrototypeOf2.default)(CompanyIsPff)).call(this, props));

    var entry = _config2.default.pffCompanyProfiles.data[_this.props.company.company_id];
    if (!entry) return _ret = null, (0, _possibleConstructorReturn3.default)(_this, _ret);

    var shortName = entry[0];
    var profile = entry[1];
    var types = entry[2].split(',');
    var url = entry[3];
    var isPrisonIndustry = entry[4];
    var isBorderIndustry = entry[5];
    var isHigherRisk = entry[6] && !entry[7]; // only "high risk" if not
    // private prison operator
    var isPrivatePrisonOperator = entry[7];

    _this.state = {
      shortName: shortName,
      profile: profile,
      types: types,
      url: url,
      isPrisonIndustry: isPrisonIndustry,
      isBorderIndustry: isBorderIndustry,
      isHigherRisk: isHigherRisk,
      isPrivatePrisonOperator: isPrivatePrisonOperator
    };
    return _this;
  }

  (0, _createClass3.default)(CompanyIsPff, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          shortName = _state.shortName,
          profile = _state.profile,
          types = _state.types,
          url = _state.url,
          isPrisonIndustry = _state.isPrisonIndustry,
          isBorderIndustry = _state.isBorderIndustry,
          isHigherRisk = _state.isHigherRisk,
          isPrivatePrisonOperator = _state.isPrivatePrisonOperator;


      var ppIcon = require('../../../static/images/icn-pp-black.svg');
      var bordersIcon = require('../../../static/images/icn-borders-black.svg');
      var highIcon = require('../../../static/images/icn-alert-red.svg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'family-modal' },
          _react2.default.createElement(
            'div',
            { styleName: 'icon-row' },
            isHigherRisk ? _react2.default.createElement(_.CompanyIsFlag, { icon: highIcon, title: 'Higher risk', color: 'red' }) : null,
            isPrivatePrisonOperator ? _react2.default.createElement(_.CompanyIsFlag, { icon: highIcon, title: 'Private prison operator', color: 'red' }) : null,
            isPrisonIndustry ? _react2.default.createElement(_.CompanyIsFlag, { icon: ppIcon, title: 'Prison industry' }) : null,
            isBorderIndustry ? _react2.default.createElement(_.CompanyIsFlag, { icon: bordersIcon, title: 'Border industry' }) : null
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-p' },
            profile
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-t' },
            'Prison industrial complex activities'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'cat-flex' },
            types.map(function (e, i) {
              return _react2.default.createElement(
                'div',
                { key: 'type-' + i, styleName: 'cat-item' },
                e.trim()
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'family-modal-u' },
            _react2.default.createElement(
              _.Link,
              {
                to: url,
                title: shortName + ' | Investigate: a project of the ' + 'American Friends Service Committee'
              },
              'Research from AFSC\'s Investigate',
              _react2.default.createElement(_.LinkIcon, null)
            )
          )
        )
      );
    }
  }]);
  return CompanyIsPff;
}(_react.Component), _class2.propTypes = {
  company: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = CompanyIsPff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyIsPanels/CompanyIsPff.js
// module id = 1382
// module chunks = 0